import { FC, useEffect } from "react";

const EmptyPage: FC = (props) => {
  useEffect(() => {
    document.title = "Empty";
  }, []);
  return null;
};

export default EmptyPage;
